export default __webpack_public_path__ + "static/media/13.c9424d93.jpg";